// @ts-nocheck
// TODO: tighten types after migration
import katex from 'katex';
import 'katex/dist/katex.min.css';
import React from 'react';
import { renderDiagram } from './DiagramRenderer';

/*
 * renderLatex — converts a string containing LaTeX delimiters into React elements.
 *
 * Handles:
 *   $$...$$ → display (block) math
 *   $...$   → inline math
 *   plain text → returned as-is
 *
 * Usage: renderLatex("The area is $A = \\pi r^2$ for a circle.")
 *        → [<span>The area is </span>, <span class="katex">...</span>, <span> for a circle.</span>]
 */

// Regex: match $$...$$ first (greedy block), then $...$ (non-greedy inline)
// Use [\s\S] for block to allow multiline, [^$] for inline to stay single-line
var LATEX_REGEX = /(\$\$[\s\S]+?\$\$|\$[^$\n]+?\$)/g;

function renderKatexString(latex, displayMode) {
    try {
        return katex.renderToString(latex, {
            displayMode: displayMode,
            throwOnError: false,
            strict: false,
            trust: true,
        });
    } catch (e) {
        // Fallback: show raw LaTeX in a code-styled span
        return '<code class="lw-latex-error">' + latex + '</code>';
    }
}

export function renderLatex(text, baseKey) {
    if (!text) return text;
    if (typeof text !== 'string') return text;

    // Quick check: no $ sign means no LaTeX
    if (text.indexOf('$') === -1) return text;

    var parts = text.split(LATEX_REGEX);
    if (parts.length === 1) return text; // no matches

    var result = [];
    var k = baseKey || 0;

    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (!part) continue;

        if (part.startsWith('$$') && part.endsWith('$$')) {
            // Block/display math
            var latex = part.slice(2, -2).trim();
            var html = renderKatexString(latex, true);
            result.push(
                <span
                    key={'ltx' + k + '_' + i}
                    className="lw-katex-block"
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            );
        } else if (part.startsWith('$') && part.endsWith('$')) {
            // Inline math
            var latexInline = part.slice(1, -1).trim();
            var htmlInline = renderKatexString(latexInline, false);
            result.push(
                <span
                    key={'ltx' + k + '_' + i}
                    className="lw-katex-inline"
                    dangerouslySetInnerHTML={{ __html: htmlInline }}
                />
            );
        } else {
            // Plain text
            result.push(part);
        }
    }

    return result;
}

/*
 * renderDiagramTag — renders a [Diagram: ...] tag as a visual SVG diagram
 * with fallback to styled text description.
 * Accepts optional onSelect callback for making diagrams selectable.
 */
export function renderDiagramTag(text, key, onSelect) {
    var match = text.match(/^\[Diagram:\s*(.*)\]$/i);
    if (!match) return null;
    var desc = match[1];
    return renderDiagram(desc, key, onSelect);
}
